import styled from 'styled-components';
import { shade } from 'polished';

const Tag = styled.span`
  width: 12px;
  height: 12px;
  display: inline-block;
  border-radius: 50%;
  background-color: ${(props) => props.theme[props.tagColor]};
  /* border: 1px solid ${(props) => shade(0.8, props.theme[props.tagColor])}; */
  border: 1px solid transparent;
  color: ${(props) => shade(0.45, props.theme[props.tagColor])};
`;

export default Tag;
